<template>
	<v-app class="ata">
		<loading></loading>
		<v-banner class="primary pa-0">
			<div class="d-flex justify-center pa-0">
				<az-logo></az-logo>
			</div>
		</v-banner>
		<v-main>
			<router-view></router-view>
			<az-loading></az-loading>
			<az-alert></az-alert>
		</v-main>
		<v-divider></v-divider>
		<v-footer class="d-flex align-center justify-center az-about">
			<span class="az-about__copywrite"> &copy;{{ yearCopywrite }} — {{ companyCopywrite }} </span>
			<span class="ms-10 az-about__version"> v{{ versionNumber }} </span>
		</v-footer>
	</v-app>
</template>

<script>
import { Alert } from '@/core/utils'

export default {
	name: 'root-page',
	data() {
		return {
			alert: new Alert(this.$store),
		}
	},
	computed: {
		versionNumber() {
			return this.$store.state.loki.product.version
		},
		yearCopywrite() {
			return new Date().getFullYear()
		},
		companyCopywrite() {
			return this.$store.state.loki.product.copywrite
		},
		mainLogo() {
			return this.$store.state.loki.product.symbolLogo
		},
	},
	mounted() {
		this.setThemeColor()
	},
	methods: {
		setThemeColor() {
			const [corPrimaria, corSecundaria] = [
				this.$store.state.parametrosSistema.corPrimaria,
				this.$store.state.parametrosSistema.corSecundaria,
			]

			if (corPrimaria && this.validarParametroCorSistema(corPrimaria)) {
				this.$vuetify.theme.themes.light.primary = this.$store.state.parametrosSistema.corPrimaria
			} else {
				this.alert.showWarning('A cor primária configurada não segue o formato de cores do sistema.')
			}

			if (corSecundaria && this.validarParametroCorSistema(corSecundaria)) {
				this.$vuetify.theme.themes.light.secondary = this.$store.state.parametrosSistema.corSecundaria
			} else {
				this.alert.showWarning('A cor secundária configurada não segue o formato de cores do sistema.')
			}
		},
		validarParametroCorSistema(parametroCorSistema) {
			const hexColorRegex = /^#[0-9a-fA-F]{6}$/

			return hexColorRegex.test(parametroCorSistema)
		},
	},
}
</script>

<style lang="stylus">
getSizeRem(size)
	unit((size / 16), rem)

/* LOGO */
img{
	min-height: 50px !important
	max-height: 50px !important
}
.v-banner--is-mobile .v-banner__wrapper
	flex-wrap: nowrap

.v-banner__wrapper
	height: 70px

html {
	overflow auto
	font 'Open Sans', Arial, 'Sans-Serif'
	box-sizing border-box
}

.ata
	background-color var(--v-principal-base) !important

	.az-container
		margin 0 20px

	.az-container.listagem
		padding getSizeRem(8) getSizeRem(24)


	/*	 V-STEPPER	 */

	.theme--light.v-stepper
		background transparent


	.v-stepper__content
		margin 0 !important
		padding 0

	.theme--light.v-stepper .v-stepper__step--active .v-stepper__label
		text-shadow 0 0 0 var(--v-primary-base)


	/* v-data-table */

	.v-data-table
		font-size getSizeRem(14)

	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th
		padding 0 .5rem
		font-size inherit

	.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
	.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
	.v-data-table > .v-data-table__wrapper > table > thead > tr > th
		font-size: inherit


	/* v-footer */

	.az-about
		border-top 1px solid #ccc
		height 36px
		background-color #f6f9f9
		color #7f7f7f
		font-size 14px
		font-weight normal
		-webkit-box-align center
		-ms-flex-align center
		align-items center
		display -webkit-box
		display -ms-flexbox
		display flex
		justify-content space-between

		.theme--light.v-footer
			background none !important

		&__copywrite
			padding-left 20px

		&__version
			padding-right 20px
</style>
